import { HelpContent } from '../../UI-Lib/Help-Tooltip';

export const ATTACHMENT_MODAL_HELP: HelpContent[] = [
    {
        helpContentId: 'attachment-modal.show-list',
        tooltipText: 'Show Attachment List'
    },
    {
        helpContentId: 'attachment-modal.hide-list',
        tooltipText: 'Hide Attachment List'
    },
    {
        helpContentId: 'attachment-modal.custom-ordering',
        tooltipText: 'Customize the order of attachments and preserve that order.',
        hasIcon: true
    }
];
